<template>
  <PlanRecord :path="'/continueEdu'"></PlanRecord>
</template>

<script>
  import PlanRecord from '@/page/modules/plan/record'
  export default {
    components: { PlanRecord },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
  .online_bg { margin-top: 0 }
</style>



// WEBPACK FOOTER //
// src/page/continueEdu/plan/record.vue